import type { Query } from 'react-query';

const MAX_RETRIES = 3;

// A 404 means the endpoint/resource doesn't exist on this backend, so asking again won't help
export const isNotFoundError = (error: any): boolean =>
  error?.response?.status === 404 || error?.response?.data?.error?.statusCode === 404;

const lastFetchWasNotFound = (query: Query<any, any, any, any>) =>
  isNotFoundError(query.state.error);

// Keep the default 3 retries for other failures, but don't retry a 404
export const retryUnlessNotFound = (failureCount: number, error: unknown): boolean =>
  !isNotFoundError(error) && failureCount < MAX_RETRIES;

// Skip window-focus / reconnect refetches after a 404. Remounting the page or tab,
// or reloading the browser, still fetches again.
export const refetchUnlessNotFound = (query: Query<any, any, any, any>): boolean =>
  !lastFetchWasNotFound(query);

// Poll every `ms`, but stop polling once the query has returned a 404.
// Call it from an inline arrow so useQuery still infers the data type from the query function:
//   refetchInterval: (_data, query) => pollUnlessNotFound(query, 5 * 60 * 1000)
export const pollUnlessNotFound = (query: Query<any, any, any, any>, ms: number): number | false =>
  lastFetchWasNotFound(query) ? false : ms;
